import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
// Ajuste o caminho do axiosConfig conforme seu projeto
import { axiosInstance } from '@/axiosConfig'; 
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { KeyRound } from 'lucide-react'; // Mudei o ícone para uma chave

export default function DefinirSenha() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token'); // Pega o token da URL
  
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  });
  
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  // URL da API (Se não estiver no axiosInstance, defina aqui ou importe do env)
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!token) {
      toast.error('Token inválido ou expirado.');
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error('As senhas não coincidem.');
      return;
    }

    setLoading(true);

    try { 
      // Chama a rota específica de Setup de Senha que vimos no seu server.py
      await axios.post(`${API_URL}/auth/setup-password`, {
        token: token,
        password: formData.password
      });

      toast.success('Senha definida com sucesso! Redirecionando...');
      
      // Espera 2 segundos para o usuário ler a mensagem e manda pro Login
      setTimeout(() => navigate('/login'), 2000);
      
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.detail || 'Erro ao definir senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
              <KeyRound className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Bem-vindo(a)</h1>
            <p className="text-gray-600 mt-2">Defina sua senha para acessar</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            
            <div>
              <Label htmlFor="password">Nova Senha</Label>
              <Input
                id="password"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                className="mt-1"
                placeholder="Mínimo 6 caracteres"
              />
            </div>

            <div>
              <Label htmlFor="confirmPassword">Confirmar Senha</Label>
              <Input
                id="confirmPassword"
                type="password"
                value={formData.confirmPassword}
                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                required
                className="mt-1"
                placeholder="Digite a senha novamente"
              />
            </div>

            <Button
              type="submit"
              className="w-full"
              disabled={loading}
              style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
            >
              {loading ? 'Salvando...' : 'Ativar Conta'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}